@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {
  display: block;

  .jui-control {
    @include form-control-mixins.jui-control-base;

    > * {
      flex: 1 100%;
    }

    &__legend {
      @include form-control-mixins.form-control-legend;

      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }

      &--has-tooltip {
        padding-right: var(--jds-space-xl);
      }
    }

    &__error {
      @include form-control-mixins.form-control-error;
    }

    &__help {
      @include form-control-mixins.form-control-help--fieldset;
    }

    &__tooltip {
      @include form-control-mixins.form-control-tooltip-fieldset;

      &--input-sm {
        @include form-control-mixins.form-control-tooltip-fieldset-sm;
      }

      &--input-lg {
        @include form-control-mixins.form-control-tooltip-fieldset;
      }
    }

    &__tooltip-text {
      @include form-control-mixins.form-control-tooltip-text;

      &--left {
        @include form-control-mixins.form-control-tooltip-text-left;
      }

      &--left-bottom {
        @include form-control-mixins.form-control-tooltip-text-left-bottom;
      }
    }

    &__tooltip-text::before {
      @include form-control-mixins.form-control-tooltip-text-before;
    }

    &__tooltip-text--left::before {
      @include form-control-mixins.form-control-tooltip-text-left-before;
    }

    &__tooltip-text--left-bottom::before {
      @include form-control-mixins.form-control-tooltip-text-left-bottom-before;
    }

    &__tooltip:hover .jui-control__tooltip-text {
      @include form-control-mixins.tooltip-hover;
    }

    &__fieldset {
      @include form-control-mixins.form-control-fieldset;

      &--inline {
        @include form-control-mixins.form-control-fieldset--inline;
        & ::slotted(*) {
          @include form-control-mixins.form-control-fieldset--inline-slotted;
        }
        .jui-control__help {
          flex: 1 100%;
        }
      }


      &--invalid {
        @include form-control-mixins.form-control-fieldset--invalid;
        &:focus-visible {
          @include form-control-mixins.form-control-fieldset--invalid-focus;
        }
      }

      &--has-focus {
        @include form-control-mixins.form-control-focused;
      }

      // size modifiers
      &--sm {
        @include form-control-mixins.form-control-fieldset--sm;
      }

      &--lg {
        @include form-control-mixins.form-control-fieldset--lg;
      }
    }

  }
}
